/**
 * Row title for a company: its name, or — when the company is unnamed — the owner's full name.
 * Prefers the server-resolved `displayName`; falls back to computing it from the owner record.
 */
export const companyLabel = (company) => {
    if (!company) return "";
    if (company.displayName) return company.displayName;
    if (company.companyName) return company.companyName;
    const owner = company.owner ?? {};
    const name = `${owner.firstName ?? ""} ${owner.lastName ?? ""}`.trim();
    return name || "Unnamed company";
};
